module.exports = __webpack_public_path__ + "img/shenhe.1809c09a.webp";